import React from "react";
import {
  Typography,
  IconButton,
  Box,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import {
  FaBitcoin,
  FaDollarSign,
  FaSterlingSign,
  FaNairaSign,
} from "react-icons/fa6";
import { SiTether } from "react-icons/si";

import { useEffect, useState } from "react";
import Preloader from "./components/Preloader";
import {
  useGetWalletTransactionById,
  useGetWalletTransactions,
  useWallet,
} from "./api/hooks/useWallet";

export default function Transactions({ setSidebarOpen }) {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch {}

  // Transaction state
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("all");

  // Filters
  const [wallets, setWallets] = useState([]);
  const [filterSearch, setFilterSearch] = useState("");

  const { data: walletData, isLoading } = useWallet();

  // Fetch wallets for filter
  useEffect(() => {
    if (!walletData) return;
  }, [walletData]);

  useEffect(() => {
    if (!wallets.length) return;
    setLoading(true);
    setError("");

    // Fetch transactions from all wallets
    const fetchAllTransactions = async () => {
      try {
        const allTransactions = [];

        for (const wallet of wallets) {
          try {
            // const res = useGetWalletTransactions({
            //   page: 1,
            //   items_per_page: 50,
            //   wallet_number_or_uuid: wallet.wallet_number || wallet.id
            // });
            // let txs = [];
            // if (res && res.data.data && res.data.transactions && res.data.transactions.data) {
            //   txs = res.data.transactions.data;
            // } else if (res && res.data.transactions && res.data.transactions.data) {
            //   txs = res.data.transactions.data;
            // }
            // // Ensure each transaction has proper data structure
            // txs = txs.map(tx => ({
            //   ...tx,
            //   id: tx.id || Math.random().toString(36).substr(2, 9),
            //   created_at: tx.created_at || tx.createdAt || tx.date || new Date().toISOString(),
            //   user_amount: tx.user_amount || tx.amount || tx.amount_value || 0,
            //   description: tx.description || tx.narration || 'No description',
            //   reference_number: tx.reference_number || tx.reference || tx.ref || '',
            //   transaction_type: tx.transaction_type || tx.type || 'unknown',
            //     status: tx.status || { label: 'Unknown', color: '#666' },
            //     wallet_info: wallet
            //   }));
            //   allTransactions.push(...txs);
          } catch (error) {
            console.error(
              `Failed to fetch transactions for wallet ${wallet.wallet_number}:`,
              error
            );
          }
        }

        // Sort by date (newest first)
        allTransactions.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        setTransactions(allTransactions);
      } catch (error) {
        console.error("Failed to fetch transactions:", error);
        setError("Failed to load transactions");
      } finally {
        setLoading(false);
      }
    };

    fetchAllTransactions();
  }, [wallets]);

  const handleOpenDetails = async (id) => {
    // setDetailsOpen(true);
    // setDetailsLoading(true);
    // try {
    //   const {data: res} = useGetWalletTransactionById(id);
    //   setDetails(res.data || res);
    // } catch (error) {
    //   console.error('Failed to fetch transaction details:', error);
    // } finally {
    //   setDetailsLoading(false);
    // }
  };

  const handleCloseDetails = () => setDetailsOpen(false);

  // Filter transactions based on active tab
  const getFilteredTransactions = () => {
    let filtered = transactions;

    if (activeTab === "all") {
      filtered = transactions;
    } else if (activeTab === "fiat") {
      filtered = transactions.filter((tx) => {
        const currency =
          tx.user_wallet?.currency?.code || tx.wallet_info?.currency?.code;
        return ["NGN", "USD", "GBP"].includes(currency);
      });
    } else if (activeTab === "crypto") {
      filtered = transactions.filter((tx) => {
        const currency =
          tx.user_wallet?.currency?.code || tx.wallet_info?.currency?.code;
        return [
          "USDT",
          "BTC",
          "ETH",
          "BNB",
          "ADA",
          "DOT",
          "LINK",
          "LTC",
          "BCH",
          "XRP",
        ].includes(currency);
      });
    }

    // Apply search filter
    if (filterSearch) {
      const searchLower = filterSearch.toLowerCase();
      filtered = filtered.filter(
        (tx) =>
          (tx.description || "").toLowerCase().includes(searchLower) ||
          (tx.reference_number || "").toLowerCase().includes(searchLower)
      );
    }

    return filtered;
  };

  // Helper for icon
  function getWalletIcon(code) {
    if (!code) return <FaDollarSign className="text-2xl" />;
    if (code === "NGN") return <span className="text-2xl">🇳🇬</span>;
    if (code === "USD") return <span className="text-2xl">🇺🇸</span>;
    if (code === "GBP") return <FaSterlingSign className="text-2xl" />;
    if (code === "USDT") return <SiTether className="text-2xl" />;
    // All other crypto currencies use Bitcoin icon
    if (
      ["BTC", "ETH", "BNB", "ADA", "DOT", "LINK", "LTC", "BCH", "XRP"].includes(
        code
      )
    ) {
      return <FaBitcoin className="text-2xl" />;
    }
    return <FaDollarSign className="text-2xl" />;
  }

  // Helper to safely render any field that might be an object
  function safeRender(field, fallback = "-") {
    if (typeof field === "object" && field !== null) {
      return field.label || field.slug || field.name || field.id || fallback;
    }
    return field || fallback;
  }

  // Helper to safely render status values
  function getStatusDisplay(status) {
    if (typeof status === "object" && status !== null) {
      return status.label || status.slug || "Unknown";
    }
    return status || "Unknown";
  }

  // Helper to get status color class
  function getStatusColorClass(status) {
    const statusText = getStatusDisplay(status).toLowerCase();
    if (statusText === "success" || statusText === "successful") {
      return "bg-green-100 text-green-800";
    } else if (statusText === "pending") {
      return "bg-yellow-100 text-yellow-800";
    } else {
      return "bg-gray-100 text-gray-800";
    }
  }

  // Helper to get status dot color
  function getStatusDotColor(status) {
    const statusText = getStatusDisplay(status).toLowerCase();
    if (statusText === "success" || statusText === "successful") {
      return "bg-green-400";
    } else if (statusText === "pending") {
      return "bg-yellow-400";
    } else {
      return "bg-gray-400";
    }
  }

  if (isLoading)
    return (
      <Preloader fullScreen={true} message="Loading your transactions..." />
    );
  if (error)
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center p-4">
        <div className="fintech-card p-8 text-center max-w-md">
          <div className="w-16 h-16 bg-danger-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <SwapHorizIcon className="text-danger-600 text-2xl" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Failed to Load Transactions
          </h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="btn-primary"
          >
            Try Again
          </button>
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 sm:gap-4">
            <button
              onClick={() => setSidebarOpen && setSidebarOpen(true)}
              className="block xl:hidden text-gray-600 hover:text-gray-900 p-1"
            >
              <MenuIcon />
            </button>
            <div className="min-w-0 flex-1">
              <h1 className="text-xl sm:text-2xl font-bold text-gray-900 truncate">
                Transactions
              </h1>
              <p className="text-sm text-gray-600 truncate">
                View and manage your transaction history
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 sm:px-6 py-6 sm:py-8">
        {/* Search Filter */}
        <div className="mb-6">
          <input
            type="text"
            placeholder="Search transactions by description or reference..."
            value={filterSearch}
            onChange={(e) => setFilterSearch(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
          />
        </div>

        {/* Transaction Tabs */}
        <div className="fintech-card animate-slide-up">
          <div className="px-4 sm:px-6 py-4 border-b border-gray-100/50">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h3 className="text-xl font-bold text-gray-900">
                  All Transactions
                </h3>
                <p className="text-sm text-gray-500">
                  Your complete transaction history
                </p>
              </div>
            </div>
          </div>

          <div className="px-4 sm:px-6 py-4">
            <div className="flex space-x-4 mb-6">
              <button
                className={`px-4 py-2 text-sm font-semibold rounded-xl transition-all duration-300 ${
                  activeTab === "all"
                    ? "bg-primary-100 text-primary-700 border border-primary-200"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                }`}
                onClick={() => setActiveTab("all")}
              >
                All
              </button>
              <button
                className={`px-4 py-2 text-sm font-semibold rounded-xl transition-all duration-300 ${
                  activeTab === "fiat"
                    ? "bg-primary-100 text-primary-700 border border-primary-200"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                }`}
                onClick={() => setActiveTab("fiat")}
              >
                Fiat
              </button>
              <button
                className={`px-4 py-2 text-sm font-semibold rounded-xl transition-all duration-300 ${
                  activeTab === "crypto"
                    ? "bg-primary-100 text-primary-700 border border-primary-200"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
                }`}
                onClick={() => setActiveTab("crypto")}
              >
                Crypto
              </button>
            </div>

            {/* Desktop Table View */}
            <div className="hidden lg:block overflow-x-auto rounded-xl border border-gray-100/50">
              <table className="fintech-table min-w-full">
                <thead>
                  <tr className="bg-gray-50/50">
                    <th className="px-4 py-3 text-left text-xs sm:text-sm font-semibold text-gray-700">
                      Date
                    </th>
                    <th className="px-4 py-3 text-left text-xs sm:text-sm font-semibold text-gray-700">
                      Amount
                    </th>
                    <th className="px-4 py-3 text-left text-xs sm:text-sm font-semibold text-gray-700">
                      Account
                    </th>
                    <th className="px-4 py-3 text-left text-xs sm:text-sm font-semibold text-gray-700">
                      Type
                    </th>
                    <th className="px-4 py-3 text-left text-xs sm:text-sm font-semibold text-gray-700">
                      Description
                    </th>
                    <th className="px-4 py-3 text-left text-xs sm:text-sm font-semibold text-gray-700">
                      Reference
                    </th>
                    <th className="px-4 py-3 text-left text-xs sm:text-sm font-semibold text-gray-700">
                      Status
                    </th>
                    <th className="px-4 py-3 text-center text-xs sm:text-sm font-semibold text-gray-700">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {getFilteredTransactions().length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center py-12">
                        <div className="text-gray-500">
                          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <SwapHorizIcon className="text-gray-400" />
                          </div>
                          <p className="font-medium">
                            No {activeTab === "all" ? "" : activeTab}{" "}
                            transactions found
                          </p>
                          <p className="text-sm">
                            Your transaction history will appear here
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    getFilteredTransactions().map((tx) => (
                      <tr
                        key={tx.id}
                        className="hover:bg-gray-50/50 transition-colors duration-200"
                      >
                        <td className="px-4 py-3 text-xs sm:text-sm text-gray-900 font-medium">
                          {tx.created_at
                            ? new Date(tx.created_at).toLocaleDateString()
                            : "-"}
                        </td>
                        <td className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-900">
                          {tx.user_wallet?.currency?.symbol ||
                            tx.wallet_info?.currency?.symbol ||
                            "₦"}
                          {parseFloat(tx.user_amount || 0).toLocaleString(
                            undefined,
                            { minimumFractionDigits: 2 }
                          )}
                        </td>
                        <td className="px-4 py-3 text-xs sm:text-sm text-gray-900">
                          <div className="flex items-center gap-2">
                            <div className="w-6 h-6 bg-primary-100 rounded-lg flex items-center justify-center">
                              {getWalletIcon(
                                tx.user_wallet?.currency?.code ||
                                  tx.wallet_info?.currency?.code
                              )}
                            </div>
                            {tx.user_wallet?.currency?.code ||
                              tx.wallet_info?.currency?.code ||
                              "NGN"}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs sm:text-sm text-gray-900">
                          {safeRender(tx.transaction_type)}
                        </td>
                        <td className="px-4 py-3 text-xs sm:text-sm text-gray-900 max-w-xs truncate">
                          {tx.description || "-"}
                        </td>
                        <td className="px-4 py-3 text-xs sm:text-sm text-gray-900">
                          {tx.reference_number || "-"}
                        </td>
                        <td className="px-4 py-3">
                          <span
                            className={`status-badge ${
                              tx.status === "completed"
                                ? "status-success"
                                : tx.status === "pending"
                                ? "status-warning"
                                : tx.status === "failed"
                                ? "status-danger"
                                : "status-info"
                            }`}
                          >
                            <span
                              className={`w-2 h-2 rounded-full mr-2 ${
                                tx.status === "completed"
                                  ? "bg-success-500"
                                  : tx.status === "pending"
                                  ? "bg-warning-500"
                                  : tx.status === "failed"
                                  ? "bg-danger-500"
                                  : "bg-primary-500"
                              }`}
                            ></span>
                            {getStatusDisplay(tx.status)}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <button
                            onClick={() => handleOpenDetails(tx.id)}
                            className="text-xs sm:text-sm text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200"
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Mobile Card View */}
            <div className="lg:hidden space-y-4">
              {getFilteredTransactions().length === 0 ? (
                <div className="text-center py-12">
                  <div className="text-gray-500">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <SwapHorizIcon className="text-gray-400" />
                    </div>
                    <p className="font-medium">
                      No {activeTab === "all" ? "" : activeTab} transactions
                      found
                    </p>
                    <p className="text-sm">
                      Your transaction history will appear here
                    </p>
                  </div>
                </div>
              ) : (
                getFilteredTransactions().map((tx) => (
                  <div
                    key={tx.id}
                    className="fintech-card p-4 hover:shadow-md transition-all duration-200"
                  >
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-primary-100 rounded-xl flex items-center justify-center">
                          {getWalletIcon(
                            tx.user_wallet?.currency?.code ||
                              tx.wallet_info?.currency?.code
                          )}
                        </div>
                        <div>
                          <div className="text-sm font-semibold text-gray-900">
                            {tx.user_wallet?.currency?.symbol ||
                              tx.wallet_info?.currency?.symbol ||
                              "₦"}
                            {parseFloat(tx.user_amount || 0).toLocaleString(
                              undefined,
                              { minimumFractionDigits: 2 }
                            )}
                          </div>
                          <div className="text-xs text-gray-500">
                            {tx.user_wallet?.currency?.code ||
                              tx.wallet_info?.currency?.code ||
                              "NGN"}
                          </div>
                        </div>
                      </div>
                      <span
                        className={`status-badge ${
                          tx.status === "completed"
                            ? "status-success"
                            : tx.status === "pending"
                            ? "status-warning"
                            : tx.status === "failed"
                            ? "status-danger"
                            : "status-info"
                        }`}
                      >
                        <span
                          className={`w-2 h-2 rounded-full mr-1.5 ${
                            tx.status === "completed"
                              ? "bg-success-500"
                              : tx.status === "pending"
                              ? "bg-warning-500"
                              : tx.status === "failed"
                              ? "bg-danger-500"
                              : "bg-primary-500"
                          }`}
                        ></span>
                        {getStatusDisplay(tx.status)}
                      </span>
                    </div>

                    <div className="space-y-2 mb-3">
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-600">Date:</span>
                        <span className="text-gray-900 font-medium">
                          {tx.created_at
                            ? new Date(tx.created_at).toLocaleDateString()
                            : "-"}
                        </span>
                      </div>
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-600">Type:</span>
                        <span className="text-gray-900 font-medium">
                          {safeRender(tx.transaction_type)}
                        </span>
                      </div>
                      <div className="flex justify-between text-xs">
                        <span className="text-gray-600">Reference:</span>
                        <span className="text-gray-900 font-medium truncate max-w-32">
                          {tx.reference_number || "-"}
                        </span>
                      </div>
                    </div>

                    <div className="mb-3">
                      <div className="text-xs text-gray-600 mb-1">
                        Description:
                      </div>
                      <div className="text-sm text-gray-900 line-clamp-2">
                        {tx.description || "-"}
                      </div>
                    </div>

                    <div className="flex justify-end">
                      <button
                        onClick={() => handleOpenDetails(tx.id)}
                        className="text-xs text-primary-600 hover:text-primary-800 font-medium transition-colors duration-200"
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        {/* Transaction Details Dialog */}
        <Dialog
          open={detailsOpen}
          onClose={handleCloseDetails}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Transaction Details</DialogTitle>
          <DialogContent>
            {detailsLoading ? (
              <div className="flex items-center justify-center py-8">
                <CircularProgress />
              </div>
            ) : details ? (
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Transaction ID
                    </label>
                    <p className="text-sm text-gray-900">{details.id}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Date
                    </label>
                    <p className="text-sm text-gray-900">
                      {details.created_at
                        ? new Date(details.created_at).toLocaleString()
                        : "-"}
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Amount
                    </label>
                    <p className="text-sm text-gray-900 font-bold">
                      {details.user_wallet?.currency?.symbol ||
                        details.wallet_info?.currency?.symbol ||
                        "₦"}
                      {parseFloat(details.user_amount || 0).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2 }
                      )}
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Type
                    </label>
                    <p className="text-sm text-gray-900">
                      {safeRender(details.transaction_type)}
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Status
                    </label>
                    <p className="text-sm text-gray-900">
                      {getStatusDisplay(details.status)}
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Reference
                    </label>
                    <p className="text-sm text-gray-900">
                      {details.reference_number || "-"}
                    </p>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Description
                  </label>
                  <p className="text-sm text-gray-900">
                    {details.description || "-"}
                  </p>
                </div>
              </div>
            ) : (
              <p className="text-gray-500">No details available</p>
            )}
          </DialogContent>
          <DialogActions>
            <button onClick={handleCloseDetails} className="btn-secondary">
              Close
            </button>
          </DialogActions>
        </Dialog>
      </main>
    </div>
  );
}
